import { render, staticRenderFns } from "./TariffedCard.vue?vue&type=template&id=2aaad798&scoped=true"
import script from "./TariffedCard.vue?vue&type=script&lang=js"
export * from "./TariffedCard.vue?vue&type=script&lang=js"
import style0 from "./TariffedCard.vue?vue&type=style&index=0&id=2aaad798&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aaad798",
  null
  
)

export default component.exports